// extracted by css-extract-rspack-plugin
export default {"logout":"VufpI140j7g5Btid","content":"EyrpnspW2VMvO69C","container":"UwcYnnmJZG09NRyb"};